import { Popover } from '@base-ui/react/popover'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface PopoverBackdropProps extends PartProps<Popover.Backdrop.Props> {
  className?: string
}

function PopoverBackdrop({ className, ...props }: PopoverBackdropProps) {
  return (
    <Popover.Backdrop
      className={twMerge(
        'animate-fadeIn bg-backdrop fixed inset-0 backdrop-blur',
        'assistant:rounded-3xl assistant:corner-smooth',
        className,
      )}
      {...props}
    />
  )
}

export { PopoverBackdrop }
